<script setup>
import { onMounted, getCurrentInstance } from 'vue'

const props = defineProps({
  text: { type: String, required: true },
  size: { type: String, default: '' },
  animation: { type: String, default: '' },
  duration: { type: Number, default: 1000 },
})

const instance = getCurrentInstance()
const headerId = `header${instance?.uid || ''}`

onMounted(() => {
  if (!props.animation) return

  const isFadeAnimation = props.animation.includes('fade')
  if (isFadeAnimation) {
    $(`#${headerId}`).css({ opacity: 0 })
  }

  $(`#${headerId}`).visibility({
    once: true,
    ...(props.animation.includes('fly')
      ? {
          onTopVisible: function () {
            $(this).transition({
              animation: props.animation,
              duration: props.duration,
            })
          },
        }
      : {
          onBottomVisible: function () {
            $(this).transition({
              animation: props.animation,
              duration: props.duration,
              onComplete: function () {
                if (isFadeAnimation) {
                  $(this).css({ opacity: 1 })
                }
              },
            })
          },
        }),
  })
})
</script>

<template>
  <div :id="headerId" class="ui header" :class="props.size" v-html="props.text" />
</template>

<style scoped></style>
